module.exports = __webpack_public_path__ + "img/2.a0a34237.jpg";